<template>
  <v-layout>
    <v-flex xs12 v-if="loading">
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </v-flex>
    <v-flex xs12 v-if="!loading">
        <v-card>
            <v-card-title class="headline primary white--text">
                Point Mapping
            </v-card-title>
            <v-card-actions class="my-2">
              <v-text-field class="mx-2" clearable v-model="search" type="text" label="Keyword filter" style="max-width:300px"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn :disabled="!items.length" class="primary" @click="massUpdateDialog=true">Mass Update</v-btn>
              <v-btn class="primary" @click="onPickFile()" :loading="loading">Upload</v-btn>
              <v-btn :disabled="!items.length" class="primary mx-2" @click="downloadCSV"><v-icon left small>fa-download</v-icon>Download</v-btn>
              <input @change="readFile" type="file" style="display:none" ref="fileInput" accept=".csv, text/csv">
              <v-btn :disabled="!items.length" class="primary" @click="configDialog = true">Split Paths</v-btn>
<!--              <v-btn :disabled="!allEquip.length" @click="viewAllEquip" class="ml-2 primary">Map Points</v-btn>-->
<!--              <v-btn :disabled="!items.length" class="primary" @click="getSuggestion">Get Suggestions</v-btn>-->
              <v-btn :disabled="!items.length" class="primary" @click="getSuggestionFromMaster" v-if="hasSiteConfigMaster">Get Suggestions from master</v-btn>
              <v-btn :disabled="!items.length" class="primary" @click="autoInferTypes">Infer types</v-btn>
<!--              <v-btn :disabled="!items2.length" class="primary" @click="suggestionsList = true">Suggestions</v-btn>-->
              <v-btn :disabled="!items.length" class="primary" @click="autoUnitsDialog = true">Units</v-btn>
              <v-btn class="primary" @click="saveTable"><v-icon left small>fa-save</v-icon>Save</v-btn>
              <v-btn class="primary mx-2" @click="clearResults"><v-icon left small>fa-trash</v-icon>Clear</v-btn>
              <pointmap-record-dialog v-model="dialog" :item="editedItem" v-on:updateItem="newItem=$event"></pointmap-record-dialog>
              <v-dialog v-model="massUpdateDialog" max-width="1750px" persistent>
                <v-card v-if="massUpdateDialog">
                  <v-card-title class="primary white--text title">Mass Update</v-card-title>
                  <v-layout class="my-2">
                    <v-flex xs6>
                      <v-card flat class="mr-2">
                        <v-card-title class="white--text title">
                          Filter
                        </v-card-title>
                        <v-container>
                          <v-layout v-for="filter in filters" :key="filter.id">
                            <v-flex xs5 class="mr-2">
                              <v-select v-if="items.length" :items="Object.keys(items[0])" v-model="filter.column" label="Column: "></v-select>
                            </v-flex>
                            <v-flex xs5>
                              <v-combobox v-if="filter.column" label="Value: " v-model="filter.value" @change="debouncedFilter" :items="getPossibleValues(filter.column)"></v-combobox>
                            </v-flex>
                            <v-btn v-if="filters.length>1" small icon @click="deleteFilter(filters.indexOf(filter))"><v-icon>fa-trash</v-icon></v-btn>
                            <v-btn small icon @click="addFilter"><v-icon>fa-plus</v-icon></v-btn>
                          </v-layout>
                          <p v-if="selected!=[]">Selected rows: {{selected.length}}</p>
                        </v-container>
                      </v-card>
                    </v-flex>
                    <v-flex xs6>
                      <v-card flat>
                        <v-card-title class="white--text title">
                          Editing
                        </v-card-title>
                        <v-container>
                          <v-layout v-for="edit in edits" :key="edit.id">
                            <v-flex xs5 class="mr-2">
                              <v-select v-if="items.length" :items="Object.keys(items[0])" v-model="edit.column" label="Select Column:"></v-select>
                            </v-flex>
                            <v-flex xs5>
                                <v-combobox v-if="edit.column" label="New Value: " v-model="edit.value"  :items="getPossibleValuesDB(edit.column)"></v-combobox>
                            </v-flex>
                            <v-btn v-if="edits.length>1" small icon @click="deleteEdit(edits.indexOf(edit))"><v-icon>fa-trash</v-icon></v-btn>
                            <v-btn small icon @click="addEdit"><v-icon>fa-plus</v-icon></v-btn>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-card-actions>
                      <v-select
                        v-if="changeRows.length"
                        style="width:600px"
                        color="white"
                        :items="Object.keys(items[0])"
                        class="mx-4"
                        multiple
                        label="Select columns to display in the table below"
                        v-model="displayColumns">
                      </v-select>
                      <v-btn
                        v-if="changeRows.length" 
                        class="mx-4 primary"
                        @click="changeColumnDisplay"
                        
                      >
                        View Columns
                      </v-btn>
                    </v-card-actions>
                  </v-layout>
                  
                    <v-data-table
                      v-if="changeRows.length"
                      disable-initial-sort
                      v-model="selected"
                      :pagination.sync="pagination"
                      select-all
                      :items="changeRows"
                      :headers="editHeaders"
                      :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    >
                      <template v-slot:headers="props">
                        <tr>
                          <th>
                            <v-checkbox
                              color="white"
                              :input-value="props.all"
                              :indeterminate="props.indeterminate"
                              hide-details
                              @click.stop="toggleAll"
                            ></v-checkbox>
                          </th>
                          <th
                            v-for="header in props.headers"
                            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                            @click="changeSort(header.value)"
                          >
                            <v-icon small>fa-arrow-up</v-icon>
                            {{ header.text }}
                          </th>
                        </tr>
                      </template>
                      <template v-slot:items="props">
                        <td>
                          <v-checkbox
                            v-model="props.selected"
                            color="white"
                            hide-details
                          ></v-checkbox>
                        </td>
                        <td v-for="header in displayColumns1" style="font-size:13px">
                            <span v-if="header==='id'">{{ props.item[config.idColumn] }}</span>
                            <span v-if="header==='path'">{{ props.item[config.pathColumn] }}</span>
                            <span v-if="header!=='path'&&header!=='id'">
                            {{props.item[header]}}
                            </span>
                        </td>
                      </template>
                    </v-data-table>
                  <v-card-actions>
                    <p class="mx-2">Instruction: For all the rows that meet the filter on the left, their selected column(s) will be replaced with the new value(s) on the right</p>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click="massUpdateTable" :disabled="selected.length==0">Apply</v-btn>
                    <v-btn @click="massUpdateDialog=false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="configDialog" width="750px" v-if="items.length" persistent>
                  <v-card color="#303030" v-if="configDialog">
                    <v-card-title class="headline primary white--text">Configuration Menu</v-card-title>
                      <v-select label="Select the column with ID" :items="Object.keys(items[0])" v-model="config.idColumn" class="mx-4"></v-select>
                      <v-select label="Select the column with path" :items="Object.keys(items[0])" v-model="config.pathColumn" class="mx-4"></v-select>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="configDialog = false">Cancel</v-btn>
                      <v-btn color="primary" @click="configSetting" :disabled="config.idColumn==null||config.pathColumn==null">Continue</v-btn>
                    </v-card-actions>
                  </v-card>
              </v-dialog>
              <v-dialog v-model="settingDialog" width="750px" v-if="items.length" persistent>
                  <v-card color="#303030" v-if="settingDialog">
                    <v-card-title class="headline primary white--text">Mapping Settings 1</v-card-title>
                      <v-container>
                        <v-switch v-model="useRefineForSensor" color="green" label="Use Refine Function"></v-switch>
                        <v-card-title class="title white--text">Text Replacing</v-card-title>
                        <v-expansion-panel v-model="panel" class="my-2">
                          <v-expansion-panel-content>
                            <template v-slot:header>
                              <div>Show All</div>
                            </template>
                            <v-card class="my-2">
                              <v-layout v-for="replace in config.replaceText">
                                <v-flex class="xs6">
                                  <v-text-field class="mx-4" v-model="replace.replace" label="Text to be replaced"></v-text-field>
                                </v-flex>
                                <v-flex class="xs6">
                                  <v-text-field class="mx-4" v-model="replace.new" label="Replacement"></v-text-field>
                                </v-flex>
                                <v-btn v-if="config.replaceText.length>1" small icon @click="deleteReplaceText(config.replaceText.indexOf(replace))"><v-icon>fa-trash</v-icon></v-btn>
                              </v-layout>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn  @click="addReplaceText"><v-icon>fa-plus</v-icon></v-btn>
                                </v-card-actions>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-card-title class="title white--text">Text Splits</v-card-title>
                        <v-text-field class="mx-4" label="Split 1 (splitter of file path)" v-model="config.split1"></v-text-field>

                        <div v-if="useRefineForSensor">
                          <v-card-title class="title white--text">Refine Function</v-card-title>
                            <v-text-field class="mx-4" label="Splitter for refine function" v-model="config.split2"></v-text-field>
                          <v-select class="mx-4" label="Number of times to run refine function" v-model="config.refineNo" :items="[0,1,2,3,4]"></v-select>
                        </div>
                      </v-container>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="settingDialog = false">Cancel</v-btn>
                      <v-btn color="primary" @click="configSetting2">Continue</v-btn>
                    </v-card-actions>
                  </v-card>
              </v-dialog>
              <v-dialog v-model="settingDialog2" width="750px" v-if="items.length" persistent>
                  <v-card color="#303030" v-if="settingDialog2">
                    <v-card-title class="headline primary white--text">Mapping Settings 2</v-card-title>
                      <v-card-text>
                          <v-layout row>
                              <v-autocomplete :items="slotPaths" v-model="precisePath"></v-autocomplete>
                              <v-btn @click="getRandomElement(slotPaths,precisePath)" primary :disabled="!precisePath">Select path</v-btn>
                              <v-btn @click="getRandomElement(slotPaths)" primary><v-icon left>fa-dice</v-icon>Random path</v-btn>
                          </v-layout>
                        <v-text-field v-if="randomPath!=null && config.pathColumn != null && items[randomPath.index] !== undefined" v-model="items[randomPath.index][config.pathColumn]" readonly label="Original Path"></v-text-field>
                        <v-text-field v-if="randomPath!=null" v-model="randomPath.path" readonly label="Refined Path Example"></v-text-field>
                        <v-switch v-model="config.skipDifferentLength" color="green" label="Skip different length paths"></v-switch>
                        <v-switch v-model="config.skipMapped" color="green" label="Skip mapped paths"></v-switch>

                        <p class="mt-3">Choose the section that IS/INCLUDES: </p>
                        <v-select :items="chooseSection" v-model="config.pathIndex.tower" label="tower" clearable></v-select>
                        <v-select :items="chooseSection" v-model="config.pathIndex.floor" label="floor" clearable></v-select>
                        <v-select :items="chooseSection" v-model="config.pathIndex.equip_type" label="equip_type" clearable></v-select>
                        <v-select :items="chooseSection" v-model="config.pathIndex.equip" label="equip" clearable></v-select>
                        <v-select :items="chooseSection" v-model="config.pathIndex.point" label="point" clearable></v-select>
                      </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="settingDialog2 = false; settingDialog = true">Return to Previous step</v-btn>
                      <v-btn @click="settingDialog2 = false">Cancel</v-btn>
                      <v-btn color="primary" @click="configResult">Continue</v-btn>
                    </v-card-actions>
                  </v-card>
              </v-dialog>
              <v-dialog v-model="equipList" width="800px" persistent>
                <v-card v-if="equipList">
                  <v-card-title class="headline primary white--text">Equip List</v-card-title>
                  <v-card-title class="mt-3">Instruction: If any changes are needed, click on the arrow button to edit</v-card-title>
                  <v-data-table
                    class="mx-4"
                    :items="allEquip"
                    disable-initial-sort
                    :headers="[{text: 'Equip', value: 'equip', align: 'right', width: '450px'}, {text: 'Duplicate Warning', value: 'duplicate'}, {text: 'View', value: 'view'}]"
                    :pagination.sync="pagination2"
                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                  >
                    <template v-slot:items="props">
                      <td style="font-size:13px" class="text-xs-right">{{props.item.equip}}</td>
                      <td v-if="props.item.duplicate==true" class="text-xs-center" style="font-size:13px"><v-icon>fa-exclamation-triangle</v-icon></td>
                      <td v-if="props.item.duplicate==false" class="text-xs-center" style="font-size:13px"></td>
                      <td style="font-size:13px"><v-icon @click="viewInMassUpdate(props.item.equip)">fa-arrow-right</v-icon></td>
                    </template>
                  </v-data-table>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="equipList=false" class="primary">Exit</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
                <v-dialog v-model="autoUnitsDialog" width="800px" persistent>
                <v-card v-if="autoUnitsDialog">
                  <v-card-title class="headline primary white--text">Auto map units</v-card-title>
                  <v-card-text>
                      <v-switch v-model="skipExistingUnits" color="green" label="Skip mapped units"></v-switch>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="autoDetectUnits(); autoUnitsDialog=false;" class="primary">Run auto-map</v-btn>
                    <v-btn @click="autoUnitsDialog=false" >Cancel</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="suggestionsList" width="1400px" v-if="items2.length" persistent>
                <v-card v-if="suggestionsList">
                  <v-container>
                    <v-data-table
                      :items="items2"
                      :headers="headers2"
                      disable-initial-sort
                      :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                      :items-per-page="25"
                      :pagination.sync="pagination3"
                    >
                      <template v-slot:items="props">
                        <td>{{props.item.name}}</td>
                        <td>{{props.item.occ}}</td>
                        <td>{{props.item.types.join(", ")}}</td>
                        <td><v-select :items="props.item.suggestions" v-model="props.item.realName"></v-select></td>
                        <td><v-text-field v-model="props.item.realName"></v-text-field></td>
                      </template>
                    </v-data-table>
                  </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="suggestionsList = false">Cancel</v-btn>
                  <v-btn color="primary" @click="updateSensors">Continue</v-btn>
                    </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
            <v-data-table
              :items="items"
              :headers="headers"
              disable-initial-sort
              :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
              :items-per-page="25"
              :search="search2"
            >
              <template v-slot:items="props">
                <td>{{props.item[config.idColumn]}}</td>
                <td>{{props.item[config.pathColumn]}}</td>
                <td>{{props.item.carnot_name}}</td>
                <td>{{props.item.point}}</td>
                <td>{{props.item.equip}}</td>
                <td>{{props.item.equip_type}}</td>
                <td>{{props.item.floor}}</td>
                <td>{{props.item.tower}}</td>
                <td>{{props.item.unit}}</td>
                <td class="justify-center layout px-0">
                  <v-btn icon small @click="editRow(props.item)"><v-icon small>fa-edit</v-icon></v-btn>
                  <v-btn icon small @click="deleteItem(props.item[config.idColumn])"><v-icon small>fa-trash</v-icon></v-btn>
                </td>
              </template>
            </v-data-table>
        </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import units from '../config/pointMapping/units'
import {getResult, putResult, getSuggestions, getFacilityList, getRule, getPoint} from '../helper'
import PointmapRecordDialog from '@/components/pointmapping/PointmapRecordDialog'
import {exportCSV} from '../tocsv'
import {mapGetters} from "vuex";
export default {
    components: {PointmapRecordDialog},
    computed: {
        ...mapGetters([
            'siteConfigMaster',
        ]),
        hasSiteConfigMaster() {
            if (!this.siteConfigMaster){
                return false
            }
            if (this.$store.state.userStore.user) {
                if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"&&this.$store.state.userStore.user.content.role==="admin"){
                    return true
                } else if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                    return this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)
                } else {
                    return this.$store.state.userStore.user.content.user_name === "jecdavid" || this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
                }
            }
            return false;
        },
    },
  data() {
    return {
      allEquip: [],
        precisePath:null,
      changeRows: [],
      config: {
        idColumn: null,
        pathColumn: null,
        split1: '/',
        split2: '_',
        refineNo: 0,
        skipDifferentLength: false,
        skipMapped: false,
        pathIndex: {
          tower: null,
          floor: null,
          equip_type: null,
          equip: null,
            point: null,
        },
        replaceText: [
          { replace: 'Chller', new: 'Chiller'},
        ],
      },
      mappingConfig: {
        floor: null,
        equip_type: null,
        equip: null
      },
      configDialog: false,
      mappingDialog: false,
      configTable: [],
      dialog: false,
      displayColumns: ['id', 'path', 'carnot_name', 'point', 'equip', 'equip_type', 'floor', 'tower','unit'],
      displayColumns1: ['id', 'path', 'carnot_name', 'point', 'equip', 'equip_type', 'floor', 'tower','unit'],
        typeAutoMatcher: {
            "chilled_water_pump": ["chwp"],
            "condenser_water_pump": ["cdwp","cwp"],
            "chilled_water_header": ["chw_header","chw"],
            "condenser_water_header": ["cdw_header",'cnd'],
            "chiller": ["chiller","acc","wcc"],
            "ch_system": ["ch_system"],
            "tank": ["tank"],
            "ahu": ["ahu"],
            "vav": ["vav"],
            "pau": ["pau"],
            "fcu": ["fcu"],
            "faf": ["faf"],
            "eaf": ["eaf"],
            "ltg": ["lighting"],
            "zone_valve": ["zv"],
            "power_analyzer": ["r0"],
            "cooling_tower": ["ct"],
            "weather": ["weather","ambient"],
        },
      editHeaders: null,
      editedIndex: null,
      editedItem: {},
      edits: [{
        id: 1,
        column: '',
        value: ''
      }],
      equipList: false,
      filters: [{
        id: 1,
        column: '',
        value: ''
      }],
      mappingObj: [],
      headers: [
        {value: 'id', text: 'id'},
        {value: 'path', text: 'path'},
        {value: 'carnot_name', text: 'carnot_name'},
        {value: 'point', text: 'point'},
        {value: 'equip', text: 'equip'},
        {value: 'equip_type', text: 'equip_type'},
        {value: 'floor', text: 'floor'},
        {value: 'tower', text: 'tower'},
        {value: 'unit', text: 'unit'},
        {value: 'actions', text: 'actions'},
      ],
      headers2: [
        {value: 'name', text: 'point'},
        {value: 'occ', text: 'occurrences'},
        {value: 'types', text: 'types'},
        {value: 'suggestions', text: 'Suggested Names'},
        {value: 'textfield', text: 'Insert carnot_name (if applicable)'}
      ],
      items: [],
      items2: [],
      loading: false,
      massUpdateDialog: false,
      newItem: '',
      pagination: {
        rowsPerPage: -1,
        sortBy: 'point'
      },
      pagination2: {
        rowsPerPage: -1,
        sortBy: 'equip'
      },
      pagination3: {
        rowsPerPage: 25,
        sortBy: 'name'
      },
      panel: [false],
      randomPath: null,
      randomRow: '',
      search: '',
      search2: '',
      selected: [],
      settingDialog: false,
      settingDialog2: false,
      slotPaths: null,
      chooseSection: [],
      splitter: "/",
      suggestionsList: false,
      useRefineForSensor: false,
      skipExistingUnits: true,
      autoUnitsDialog: false,
        existingValues:{}
    }
  },
  methods: {
      getPossibleValues(key){
          return ([...new Set(this.items.filter(x=>x[key]).map(x=>x[key]))].sort())
      },
      getPossibleValuesDB(key){
          return this.existingValues[key] ? [...new Set([...this.existingValues[key],...this.items.filter(x=>x[key]).map(x=>x[key])])].sort() : [...new Set(this.items.filter(x=>x[key]).map(x=>x[key]))].sort()
      },
    addEdit(){
      this.edits.push({
        id: this.edits.length+1,
        column: '',
        value: ''
      })
    },
    addFilter(){
      this.filters.push({
        id: this.filters.length+1,
        column: '',
        value: ''
      })
    },
    addReplaceText(){
      this.config.replaceText.push({
        replace: '',
        new: ''
      })
    },
      debouncedFilter(){
          this.debounce(this.applyFilter,500);
      },
    applyFilter(){
      let items = JSON.parse(JSON.stringify(this.items))
      let filters = JSON.parse(JSON.stringify(this.filters))
      for(let i in filters){
          let star=false
          let starFilter=null
          let filterMode="end"
          if(filters[i].value&&filters[i].value.includes("*")) {
              starFilter = filters[i].value.replaceAll("*", "").toLowerCase();
              star=true
              if(filters[i].value.startsWith("*")&&filters[i].value.endsWith("*")){
                  filterMode="include"
              } else if(filters[i].value.endsWith("*")){
                  filterMode="start"
              }
          }
        for(let j = 0; j<items.length; j++){
            if(star){
                if(!items[j][filters[i].column]||(
                    (filterMode==="include"&&!items[j][filters[i].column].toLowerCase().includes(starFilter))||
                    (filterMode==="start"&&!items[j][filters[i].column].toLowerCase().startsWith(starFilter))||
                    (filterMode==="end"&&!items[j][filters[i].column].toLowerCase().endsWith(starFilter))
                )){
                    items.splice(j, 1)
                    j--
                }
            } else {
                if(items[j][filters[i].column] !== filters[i].value){
                    items.splice(j, 1)
                    j--
                }
            }

        }
      }
      this.changeColumnDisplay()
      this.selected = items
      this.changeRows = items
    },
    changeColumnDisplay(){
      this.editHeaders = []
      this.displayColumns1 = this.displayColumns
      let columns = this.displayColumns
      for(let i in columns){
        this.editHeaders.push({text: columns[i], value: columns[i]})
      }
    },
    async clearResults(){
      let me = this
      if(confirm('Are you sure you want to clear results? This action cannot be undone.')){
        me.items = []
        me.allEquip = []
        me.items2 = []
        await putResult({
          'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
          'content': {items: [], allEquip: [], config: this.config, items2: []},
          'result_name': 'Mapping Table',
          'description': 'description'
        })
        me.$store.dispatch('callSnackbar', {text: 'Results Cleared'}) 
      }
      
    },
    close () {
      this.editDialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    configSetting(){
      this.configDialog = false
      this.settingDialog = true
    },
    configSetting2(){
      this.settingDialog = false
      let config = this.config
      this.panel = [false]
      let slotPaths = []
      let items = JSON.parse(JSON.stringify(this.items))
      for(let i in items){
        let cleanSlotPath = items[i][config.pathColumn]
        for(let k in config.replaceText){
          cleanSlotPath = cleanSlotPath.replaceAll(config.replaceText[k].replace, config.replaceText[k].new)
        }
          slotPaths.push(cleanSlotPath.split(config.split1).map(x=>x.trim()).filter(x=>x!==""))
      }
        if(!this.useRefineForSensor){
            config.refineNo = 0
        } else {
            for(let j = 0; j < config.refineNo; j++){
                this.refineLast(slotPaths, config.split2)
            }
        }
      this.slotPaths = slotPaths
      this.getRandomElement(slotPaths)
      this.settingDialog2 = true
    },
    configResult(){
      this.loading = true
      let items = JSON.parse(JSON.stringify(this.items))
      this.items = this.detectAll(items)
      this.settingDialog = false
      this.settingDialog2 = false
      this.loading = false
    },
      autoDetectUnits(){
          let items = JSON.parse(JSON.stringify(this.items))
          for (let item of items){
              if(this.skipExistingUnits&&item.unit&&item.unit!==""){
                  continue
              } else {
                  let name = item.carnot_name&&item.carnot_name!=="" ? item.carnot_name : item.point
                  if(name&&name!==""){
                      if(units.standard.exact[name]){
                          item.unit=units.standard.exact[name]
                      } else {
                          let subnames=name.split("_").map(x=>x.toLowerCase())
                          for (let key in units.standard.matched){
                              if (units.standard.matched[key].filter(x=>subnames.includes(x)).length>0){
                                  item.unit=key
                                  break
                              }
                          }
                      }
                  }
              }
          }
          this.items=items
      },
    viewAllEquip(){
      this.equipList = true
    },
    viewInMassUpdate(equip){
      this.loading = true
      this.filters = [{
        id: 1,
        column: 'equip',
        value: equip
      }]
      this.displayColumns = ['id', this.config.pathColumn, 'point']
      this.applyFilter()
      this.loading = false
      this.massUpdateDialog = true
    },
    debounce(callback, wait) {
      clearTimeout(this.timeout);
      this.timeout= setTimeout(() => callback(), wait);
    },
    deleteEdit(index){
      this.edits.splice(index, 1)
    },
    deleteFilter(index){
      this.filters.splice(index, 1)
    },
    deleteReplaceText(index){
      this.config.replaceText.splice(index, 1)
    },
    deleteItem (id) {
      let index = null
      let items = this.items
      for(let i in items){
        if(items[i][this.config.idColumn] == id){
          index = i
          break
        }
      }
      if (confirm('Are you sure you want to delete this row?') ){
        this.items.splice(index, 1)
        if(this.mappingDialog == true){
          let rows = this.mappingObj
          for(let i in rows){
            for(let j in rows[i].rows){
              if(rows[i].rows[j][this.config.idColumn] == id){
                rows[i].rows.splice(j, 1)
                break
              }
            }
          }
          
        }
      }
    },
    detectAll(items){
      let config = this.config
      this.allEquip = []
      let slotPaths = []
      let allEquip = []
      let equipCheck = []
      for(let i in items){
        let cleanSlotPath = items[i][config.pathColumn]
        for(let k in config.replaceText){
          cleanSlotPath = cleanSlotPath.replaceAll(config.replaceText[k].replace, config.replaceText[k].new)
        }
        slotPaths.push(cleanSlotPath.split(config.split1).map(x=>x.trim()).filter(x=>x!==""))
      }
      if(!this.useRefineForSensor){
        config.refineNo = 0
      } else {
          for(let j = 0; j < config.refineNo; j++){
              this.refineLast(slotPaths, config.split2)
          }
      }
      let chosenPathLength=this.chooseSection.length/2
      let skippedPaths=0
      for(let k in slotPaths){
        if(slotPaths[k]&&slotPaths[k]!==''){
            if(config.skipMapped&&items[k]&&((items[k].point&&items[k].point!=="")||(items[k].equip&&items[k].equip!==""))){
                skippedPaths = skippedPaths+1
                continue
            }
            let refinedPath = slotPaths[k]
            if(config.skipDifferentLength&&chosenPathLength!==refinedPath.length){
                skippedPaths = skippedPaths+1
                continue
            }
          let row={
              tower: null,
              floor: null,
              equip_type: null,
              equip: null,
              point: null,
          }
          let accurate = true
          let inList = false
            for (let segment of ["tower","floor","equip_type","equip","point"]){
                if(config.pathIndex[segment]!==null){
                    let realIndex=config.pathIndex[segment] < 0 ? refinedPath.length+config.pathIndex[segment] : config.pathIndex[segment]
                    if(refinedPath[realIndex]){
                        row[segment]=refinedPath[realIndex]
                    }
                }
            }
          if(row.equip != null){
            for(let l in allEquip){
              if(allEquip[l].equip === row.equip && !accurate){
                inList = true
                break
              }
            }
            if(!inList && !accurate){
              allEquip.push({'equip': row.equip, 'duplicate': false})
            }
            for(let m in equipCheck){
              if(equipCheck[m].equip === row.equip){
                equipCheck[m].items.push(items[k])
                break
              }
            }
            if(!inList){
              equipCheck.push({'equip': row.equip, 'items': [items[k]]})
            }
          }
          items[k].tower = row.tower
          items[k].floor = row.floor
          items[k].equip_type = row.equip_type
          items[k].equip = row.equip
          items[k].point = row.point
        }
      }
      let message="Path split complete."
        if(skippedPaths>0){
            message=message+" Skipped "+skippedPaths+" paths."
        }
        this.$store.dispatch('callSnackbar', {text: message})
      this.allEquip = allEquip
      this.checkDuplicates(equipCheck)
        return items
    },
    checkDuplicates(equipCheck){
      let duplicateCheck = []
      let allEquip = this.allEquip
      for(let n in equipCheck){
        let list = {'equip': equipCheck[n].equip, 'sensors': [], 'duplicate': false}
        for(let o in equipCheck[n].items){
          list.sensors.push(equipCheck[n].items[o].point)
        }
        if(new Set(list.sensors).size !== list.sensors.length){
          list.duplicate = true
          let index = allEquip.findIndex(e => e.equip === list.equip)
          if(index === -1){
            allEquip.push({'equip': list.equip, 'duplicate': true})
          }
          else{
            allEquip[index].duplicate = true
          }
        }
        duplicateCheck.push(list)
      }
      return duplicateCheck
    },
    updateList(){
      let filters = this.filters
      let edits = this.edits
      let items = JSON.parse(JSON.stringify(this.items))
      let allEquip = JSON.parse(JSON.stringify(this.allEquip))
      let oldEquip = null
      let newEquipName = null
      let newEquip = true
      for(let i in edits){
        if(edits[i].column === 'equip'){
          newEquipName = edits[i].value
          for(let j in allEquip){
            if(allEquip[j].equip === newEquipName){
              newEquip = false
              break
            }
          }
          if(newEquip){
            allEquip.push({'equip': newEquipName})
          }
          break
        }
      }
      for(let k in filters){
        if(filters[k].column === 'equip'){
          let hasRemain = false
          oldEquip = filters[k].value
          for(let l in items){
            if(items[l].equip === filters[k].value){
              hasRemain = true
              break
            }
          }
          if(!hasRemain){
            let index = allEquip.map(e => e.equip).indexOf(oldEquip)
            allEquip.splice(index, 1)
          }
          break
        }
      }
      this.allEquip = allEquip
    },
    getRandomElement(slotPaths,preciseItem=null){
      let num = Math.floor(Math.random()*slotPaths.length)
        if(preciseItem){
            num=slotPaths.indexOf(preciseItem)
        }
      let path = null
      let length=slotPaths[num].length
      let pospaths= slotPaths[num].map((item, index) => {return{text:index+ " : "+item,value:index} })
      let negpaths= slotPaths[num].map((item, index) => {let inverted=index-length; return{text:inverted+ " : "+item,value:inverted} })
      this.chooseSection = [...pospaths,...negpaths]
      path = slotPaths[num].join('  ,  ')
      this.randomPath = {'path': path, 'index': num}
    },
    downloadCSV(){
      let cleanedItems = JSON.parse(JSON.stringify(this.items))
        for (let item of cleanedItems){
            if(item.tower&&item.tower!==""){
                if(!item.floor||item.floor===""){
                    item.floor=item.tower
                } else {
                    item.floor=item.tower+">"+item.floor
                }
            }
            if(!item.site){
                item.site=this.$store.state.pointsListStore.pointsList.facility_name
            }
            for (let key of ['carnot_name', 'point', 'equip', 'equip_type', 'floor', 'tower','sensor_desc']){
                if (!item[key]){
                    item[key]=""
                }
            }
            if(!item.unit){
                item.unit="_"
            }
            if(!item.meta){
                item.meta="{}"
            }
            if(!item.equip_meta){
                item.equip_meta="{}"
            }
            let name=item.carnot_name&&item.carnot_name!=="" ? item.carnot_name : item.point
            item.csv_col_name=item.equip+" - "+name
        }
      exportCSV(cleanedItems)
    },
    editRow(row){
      this.editedIndex = this.items.indexOf(row)
      this.editedItem = Object.assign({}, row)
      this.dialog = true
    },
    massUpdateTable(){
      let items = JSON.parse(JSON.stringify((this.items)))
      let selected = JSON.parse(JSON.stringify((this.selected)))
      let edits = JSON.parse(JSON.stringify(this.edits))
      for(let i in items){
        for(let j in selected){
          if(items[i].point === selected[j].point&&items[i].equip === selected[j].equip){
            for(let k in edits){
              items[i][edits[k].column] = edits[k].value
            }
          }
        }
      }
      this.items = items
      this.applyFilter()
      this.updateList()
    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    async readFile(e){
      let me = this
      this.loading = true
      this.items = []
      let file = e.target.files[0]
      let arr = []
      this.allEquip = []
      this.items2 = []
      await this.$papa.parse(file, {
        download: true,
        worker: true,
        header: true,
        step: function(results){
          delete results.data[""]
          arr.push(results.data)
        },
        complete: function(){
          arr.pop()
          me.config.pathColumn = null
          me.displayColumns = ['id', 'point', 'equip', 'equip_type', 'floor', 'tower']
          me.items = arr
          me.loading = false
          me.configDialog = true
        }
      })
    },
    async saveTable(){
      await putResult({
        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
        'content': {items: this.items, allEquip: this.allEquip, config: this.config, items2: this.items2},
        'result_name': 'Mapping Table',
        'description': 'description'
      })
      this.$store.dispatch('callSnackbar', {text: 'Table saved'}) 
    },
    async getSuggestion(){
      let me = this
      this.loading = true
      await getSuggestions({
        'items': this.items,
        'config': this.config
      }).then(function(res){
        let items = JSON.parse(JSON.stringify(me.items))
        let sensorsList = []
        for(let i in res.items){
          if(res.suggestion[i].error == 'No Error'){
            items[i].carnot_name = res.suggestion[i].fuzzy_name
          }
          else if(res.suggestion[i].error == 'DOUBTFUL'){
            // items[i].carnot_name = res.suggestion[i].point
            let inList = false
            for(let j in sensorsList){
              if(items[i].point == sensorsList[j].name){
                sensorsList[j].ids.push(items[i][me.config.idColumn])
                sensorsList[j].occ=sensorsList[j].occ+1
                  if(sensorsList[j].types.indexOf(items[i].equip_type)===-1){
                      sensorsList[j].types.push(items[i].equip_type)
                  }
                inList = true
                break
              }
            }
            if(inList == false){
              let suggestions = res.suggestion[i].possible_fuzzy_names
              let arr = []
              for(let suggestion of suggestions){
                  let score=suggestion[1]+suggestion[2]
                arr.push({
                    value:suggestion[0],
                    text:suggestion[0]+" ("+score.toString()+")",
                    score:score
                })
              }
              arr.sort((a, b) => (a.score > b.score) ? -1 : 1)
              sensorsList.push({'name': items[i].point, 'suggestions': arr, 'ids': [items[i][me.config.idColumn]], realName: '', types:[items[i].equip_type], occ:1})
            }
          }
          else{
            // items[i].carnot_name = res.suggestion[i].point
          }
        }
        me.items2 = sensorsList
        me.items = items
        me.suggestionsList = true
        me.loading = false
      })
    },
      autoInferTypes(){
          this.loading=true
          let items = JSON.parse(JSON.stringify(this.items))
          for (let item of items){
              if (item.equip){
                  for (let type in this.typeAutoMatcher){
                      if (this.typeAutoMatcher[type].filter(x=>item.equip.toLowerCase().includes(x)).length>0){
                          item.equip_type=type
                          break
                      }
                  }
              }
          }
          this.items = items
          this.loading = false
      },
      async getSuggestionFromMaster() {
          this.loading = true
          let remoteFacilities = await getFacilityList(
              {
                  apiBaseUrl: this.siteConfigMaster
              }
          )
          let remotePoints = await getPoint(
              {
                  apiBaseUrl: this.siteConfigMaster,
                  facility_name: remoteFacilities.facilities[0].facility_name
              }
          )
          let nameHolder={}
          for (let remotePoint of remotePoints.result){
              if (remotePoint.sensor_desc&&remotePoint.sensor_desc!==""&&remotePoint.sensor_name&&remotePoint.sensor_name!==""){
                  nameHolder[remotePoint.sensor_desc.toLowerCase()]=remotePoint.sensor_name
              }
          }
          // let namesArray = Object.keys(nameHolder)
          // function levenshteinDistance(a, b) {
          //     const matrix = [];
          //
          //     for (let i = 0; i <= b.length; i++) {
          //         matrix[i] = [i];
          //     }
          //
          //     for (let j = 0; j <= a.length; j++) {
          //         matrix[0][j] = j;
          //     }
          //
          //     for (let i = 1; i <= b.length; i++) {
          //         for (let j = 1; j <= a.length; j++) {
          //             if (b.charAt(i - 1) === a.charAt(j - 1)) {
          //                 matrix[i][j] = matrix[i - 1][j - 1];
          //             } else {
          //                 matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j] + 1);
          //             }
          //         }
          //     }
          //
          //     return matrix[b.length][a.length];
          // }
          // function findMostSimilar(givenString, stringArray) {
          //     let mostSimilar = stringArray[0];
          //     let minDistance = levenshteinDistance(givenString, stringArray[0]);
          //
          //     for (let i = 1; i < stringArray.length; i++) {
          //         const distance = levenshteinDistance(givenString, stringArray[i]);
          //         if (distance < minDistance) {
          //             minDistance = distance;
          //             mostSimilar = stringArray[i];
          //         }
          //     }
          //
          //     return mostSimilar;
          // }
          let items = JSON.parse(JSON.stringify(this.items))
          let mappedAlready={}
            for (let item of items){
                let foundName=null
                if (item.point&&nameHolder[item.point.toLowerCase()]){
                    foundName=nameHolder[item.point.toLowerCase()]
                } else if (item.point&&item.point!==""){
                    // let closest=findMostSimilar(item.point.toLowerCase(), namesArray)
                    // if (levenshteinDistance(item.point.toLowerCase(), closest)<3){
                    //     item.carnot_name=nameHolder[closest]
                    // }
                    let splited=item.point.toLowerCase().split("_")
                    while (splited.length>1){
                        splited.shift()
                        let newMatch=splited.join("_")
                        if (nameHolder[newMatch]){
                            foundName=nameHolder[newMatch]
                            break
                        }
                    }
                }
                if (foundName){
                    if (item.equip&&mappedAlready[item.equip+" - "+foundName]){
                        let counter = 2
                        let newName=item.equip+" - "+foundName+"_"+counter.toString()
                        while (mappedAlready[newName]){
                            counter++
                            newName=item.equip+" - "+foundName+"_"+counter.toString()
                        }
                        foundName=foundName+"_"+counter.toString()
                    }
                    item.carnot_name=foundName
                    if (item.equip){
                        mappedAlready[item.equip+" - "+foundName]=true
                    }
                }
            }
          this.items = items
          this.loading = false
      },
    updateSensors(){
      let items = JSON.parse(JSON.stringify(this.items))
      let items2 = this.items2
      for(let sitem of items2){
        if(sitem.realName&&sitem.realName !== ""){
          for (let item of items){
              if(item.point===sitem.name){
                  item.carnot_name=sitem.realName
              }
          }
        }
      }
      this.items = items
      this.suggestionsList = false
    },
    syncSearches(){
      this.search2=this.search
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.changeRows.slice()
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    refineLast(paths, splitter) {
      let lastParts=paths.map(x=>x.pop())
      for (let index in lastParts){
        if (lastParts[index].indexOf(splitter)===-1){
          paths[index].push(lastParts[index])
        } else {
          let lastPart=lastParts[index]
            let splitLastPart=lastPart.split(splitter)
            let subLength = 1
            let equipName=splitLastPart[0]
            let matchingPaths = lastParts.filter(e=>e.startsWith(equipName+splitter)).length
            while (subLength<splitLastPart.length){
              if (subLength>1&&!isNaN(parseInt(splitLastPart[subLength-1]))&&isNaN(parseInt(splitLastPart[subLength]))){
                  break;
              }
              if(!isNaN(parseInt(splitLastPart[subLength]))){
                subLength = subLength+1
                equipName = splitLastPart.slice(0,subLength).join(splitter)
                matchingPaths = lastParts.filter(e=>e.startsWith(equipName+splitter)).length
              } else {
                let newEquipName = splitLastPart.slice(0,subLength+1).join(splitter)
                let newMatchingPaths = lastParts.filter(e=>e.startsWith(newEquipName+splitter)).length
                if(newMatchingPaths<matchingPaths){
                  break
                } else {
                  subLength = subLength+1
                  equipName = newEquipName
                  matchingPaths = newMatchingPaths
                }
              }
            }
            paths[index].push(equipName)
            paths[index].push(lastPart.substring(equipName.length+splitter.length))
          }
      }
    }
  },
  watch: {
    search(){
      this.debounce(this.syncSearches,500);
    },
    newItem(){
      if(this.newItem != ''){
        let items = JSON.parse(JSON.stringify(this.items))
        for(let i in items){
          if(items[i][this.config.idColumn] == this.newItem[this.config.idColumn]){
            items.splice(i, 1, this.newItem)
            break
          }
        }
        this.items = items
      }
    }
  },
  async mounted(){
    let me = this
    this.loading = true
    await getResult({
      facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
      result_name: 'Mapping Table'
    }).then(function(res) {
      if(res.result.length != 0){
        me.items = res.result[0].content.items
        me.config = res.result[0].content.config
        me.allEquip = res.result[0].content.allEquip
        me.items2 = res.result[0].content.items2
      }
    })
      let combinations = this.$store.state.pointsListStore.pointsList.points_list.map(sensor => {
          let floor = null
          let tower = null
          if(this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].floor) {
              let floorbase = this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].floor.split('>')
              if (floorbase.length > 1) {
                  tower = floorbase[0]
                  floor = floorbase.slice(1).join('>')
              } else {
                  floor = floorbase[0]
              }
          }
          return {
              point: sensor.sensor_name,
              equip: sensor.equipment_name,
              equip_type: this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_type,
              floor: floor,
              tower: tower,
          }
      })
      let existingValues={}
      for (let key of ["point","equip","equip_type", "floor","tower"]){
          existingValues[key]=[...new Set(combinations.filter(x=>x[key]).map(x=>x[key]))]
      }
      this.existingValues=JSON.parse(JSON.stringify(existingValues))
    this.loading = false
  }
}
</script>

<style scoped>
  th {
   text-align: left;
  }
</style>
